<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
            <br>
            <v-card>
              <v-row>
                <v-col cols="12" v-if="dataItemHeader.empFull_NameTH">
                  <v-card elevation="2">
                    <v-toolbar color="red" dark>
                      <v-toolbar-title>หัวหน้างาน</v-toolbar-title>
                    </v-toolbar>
                    <v-row>
                      <v-col cols="3">
                        <v-avatar
                          class="profile"
                          style="margin-top: 20px; margin-left: 10px"
                          color="grey"
                          size="100"
                          rounded
                        >
                          <v-img
                            v-if="dataItemHeader.empImageUrl"
                            :src="DNS + dataItemHeader.empImageUrl"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                      <v-col>
                        <v-card-text class="text-left">
                          รหัส: {{ dataItemHeader.empCode }} <br />
                          ชื่อ: {{ dataItemHeader.empFull_NameTH }} <br />
                          แผนก: {{ dataItemHeader.masDepartmentName }} <br />
                          สาขา: {{ dataItemHeader.masBranchName }} <br />
                          เบอร์ติดต่อ:
                          <a
                            :href="'tel:' + dataItemHeader.empTel"
                            target="_blank"
                            >{{ dataItemHeader.empTel }}</a
                          >
                          เบอร์ติดต่อฉุกเฉิน:
                          <a
                            v-if="dataItemHeader.empEmergencyCall"
                            :href="'tel:' + dataItemHeader.empEmergencyCall"
                            target="_blank"
                            >{{ dataItemHeader.empEmergencyCall }}</a
                          >
                          <br />
                          <br />
                          อีเมล์:
                          <a
                            :href="'mailto:' + dataItemHeader.empEmail"
                            target="_blank"
                            >{{ dataItemHeader.empEmail }}</a
                          >
                        </v-card-text>
                          <v-card-actions>
                          <v-btn
                            elevation="2"
                            color="info"
                            text
                            @click="getInfo(dataItemHeader), (dialogView = true)"
                          >
                            <v-icon left> mdi-account</v-icon>
                            ดูข้อมูลเพิ่มเติม
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  v-for="(itemsTeam, indexTeam) in dataItemTeam"
                  :key="indexTeam"
                >
                  <v-card elevation="2">
                    <v-toolbar color="#262A34" dark>
                      <v-toolbar-title>ทีมงาน</v-toolbar-title>
                    </v-toolbar>
                    <v-row>
                      <v-col cols="3">
                        <v-avatar
                          class="profile"
                          style="margin-top: 20px; margin-left: 10px"
                          color="grey"
                          size="100"
                          rounded
                        >
                          <v-img
                            v-if="itemsTeam.empImageUrl"
                            :src="DNS + itemsTeam.empImageUrl"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                      <v-col>
                        <v-card-text class="text-left">
                          รหัส: {{ itemsTeam.empCode }} <br />
                          ชื่อ: {{ itemsTeam.empFull_NameTH }} <br />
                          แผนก: {{ itemsTeam.masDepartmentName }} <br />
                          สาขา: {{ itemsTeam.masBranchName }} <br />
                          เบอร์ติดต่อ:
                          <a
                            :href="'tel:' + itemsTeam.empTel"
                            target="_blank"
                            >{{ itemsTeam.empTel }}</a
                          >
                          <br />
                          เบอร์ติดต่อฉุกเฉิน:
                          <a
                            v-if="itemsTeam.empEmergencyCall"
                            :href="'tel:' + itemsTeam.empEmergencyCall"
                            target="_blank"
                            >{{ itemsTeam.empEmergencyCall }}</a
                          >
                          <br />
                          อีเมล์:
                          <a
                            :href="'mailto:' + itemsTeam.empEmail"
                            target="_blank"
                            >{{ itemsTeam.empEmail }}</a
                          >
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            elevation="2"
                            color="info"
                            text
                            @click="getInfo(itemsTeam), (dialogView = true)"
                          >
                            <v-icon left> mdi-account</v-icon>
                            ดูข้อมูลเพิ่มเติม
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-dialog
                  v-model="dialogView"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogView = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>ข้อมูล</v-toolbar-title>
                  </v-toolbar>

                  <v-card>
                          <v-row>
                        <v-col cols="12">
                            <v-select
                              v-model="month"
                              :items="monthNameTH"
                              dense
                              outlined
                              hide-details
                              label="เดือน"
                            ></v-select>
                             </v-col>
                             <v-col cols="12">
                            <v-select
                              v-model="year"
                              :items="yearsNumber"
                              dense
                              outlined
                              hide-details
                              label="ปี"
                            ></v-select>
                            </v-col>
                            <v-col cols="12">
                            <v-btn
                              block
                              elevation="2"
                              color="info"
                              text
                              @click="shift_import()"
                            >
                              <v-icon left>mdi-calendar-search</v-icon>
                              ค้นหา
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-center">วัน</th>
                            <th class="text-center">ลา</th>
                            <th class="text-center">ประเมินความเสี่ยง</th>
                          </tr>
                        </thead>
                        <tbody class="text-center">
                          <tr v-for="(items, index) in shifttem" :key="index">
                            <td>
                              {{ items.shiftDay }}
                            </td>
                            <td>
                              <v-chip
                                class="ma-2"
                                :color="items.colorin"
                                text-color="white"
                              >
                                {{ items.checkInStartStamp }}
                              </v-chip>
                            </td>
                            <td v-if="items.color" class="text-center">
                              <v-chip
                                v-if="items.color === 'สีเขียว'"
                                class="ma-2"
                                color="green"
                                text-color="white"
                              >
                                {{ items.color }}
                              </v-chip>
                              <v-chip
                                v-if="items.color === 'สีเหลือง'"
                                class="ma-2"
                                color="yellow"
                                text-color="black"
                              >
                                {{ items.color }}
                              </v-chip>
                              <v-chip
                                v-if="items.color === 'สีส้ม'"
                                class="ma-2"
                                color="orange"
                                text-color="black"
                              >
                                {{ items.color }}
                              </v-chip>
                              <v-chip
                                v-if="items.color === 'สีแดง'"
                                class="ma-2"
                                color="red"
                                text-color="white"
                              >
                                {{ items.color }}
                              </v-chip>
                            </td>
                            <td v-if="!items.color" class="text-center">-</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="2"
                        x-large
                        color="dark darken-1"
                        text
                        @click="dialogView = false"
                      >
                        <v-icon left> mdi-cancel</v-icon>
                        ปิด
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card>
            <br>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      DNS: this.DNS_IP,
      imageUrlBack: '',
      imageHeadHRM: '',
      shifttem: [],
      dataItemReport: [],
      dataReportMonth: [],
      profile: [],
      dataItemTeam: [],
      dataItemHeader: [],
      year: '',
      month: '',
      day: '',
      dataReady: true,
      dialogView: false,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'tabInfo'
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.DNS = this.DNS_IP
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    await this.getEmployeeTeam()
    await this.getEmployeeHeader()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getEmployeeTeam () {
      this.dataItemTeam = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/getTeam?masDepartmentCode=' +
            this.profile.masDepartmentCode +
            '&empCode' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItemTeam = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getEmployeeHeader () {
      this.dataItemHeader = []
      if (this.profile.positionHeader) {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/employee/get?positionCode=' +
              this.profile.positionHeader,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            this.dataItemHeader = response.data[0]
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getInfo (item) {
      this.profile = item
      this.shift_import()
    },
    async shift_import () {
      // const today = new Date()
      this.shifttem = []

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      // var monthSearch = (this.month !== null)
      //   ? '&shiftMonth=' + this.getMonthThToINT(this.month)
      //   : ''

      var url =
        '/shift_import/getEmpCodeShiftMonth?empCode=' +
        this.profile.empCode +
        '&shiftMonth=' +
        monthSearch +
        '&shiftYear=' +
        this.year

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          this.shifttem = response.data
          this.shifttem.forEach((shifttem) => {
            shifttem.colorout = 'green'

            shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
            shifttem.colorout = '-'

            if (shifttem.shiftCode === 'H') {
              shifttem.detail = 'วันหยุด'
            }
            if (shifttem.leave !== null) {
              shifttem.detail = shifttem.leave
              shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInStartStamp
              shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInEndStamp
              shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorin
              shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorout
            }
          })
          // console.log('shifttem', this.shifttem)
          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/Team.vue